import type { ElementType, ReactNode } from 'react'

const sizeClasses = {
  page: 'max-w-page',
  container: 'max-w-container',
  content: 'max-w-content',
}

type ContainerSize = keyof typeof sizeClasses

type ContainerProps<T extends ElementType> = {
  as?: T
  size?: ContainerSize
  className?: string
  children: ReactNode
}

function Container<T extends ElementType = 'div'>(
  { as, size = 'container', className, children }: ContainerProps<T>
) {
  const Comp = as ?? 'div'
  const classes = [
    'mx-auto w-full px-page-gutter xl:px-content-inset 3xl:px-content-inset-wide',
    sizeClasses[size],
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return <Comp className={classes}>{children}</Comp>
}

export default Container
